import * as types from '../constants/actionTypes';

const initialState = {
  quotations: [],
  currentQuotation: null,
  comparativeData: [],
  loading: false,
  actionLoading: false,
  error: null,
};

const replaceInList = (list, updated) =>
  list.map((q) => (q.id === updated.id ? updated : q));

const quotationReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Create ────────────────────────────────────────────────────────────────
    case types.CREATE_QUOTATION_REQUEST:
      return { ...state, actionLoading: true, error: null };
    case types.CREATE_QUOTATION_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        quotations: [action.payload, ...state.quotations],
      };
    case types.CREATE_QUOTATION_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    // ── List ──────────────────────────────────────────────────────────────────
    case types.FETCH_QUOTATIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_QUOTATIONS_SUCCESS:
      return { ...state, loading: false, quotations: action.payload || [] };
    case types.FETCH_QUOTATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // ── Single ────────────────────────────────────────────────────────────────
    case types.FETCH_QUOTATION_REQUEST:
      return { ...state, loading: true };
    case types.FETCH_QUOTATION_SUCCESS:
      return { ...state, loading: false, currentQuotation: action.payload };
    case types.FETCH_QUOTATION_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // ── Update Status ─────────────────────────────────────────────────────────
    case types.UPDATE_QUOTATION_STATUS_REQUEST:
      return { ...state, actionLoading: true, error: null };
    case types.UPDATE_QUOTATION_STATUS_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        quotations: replaceInList(state.quotations, action.payload),
        currentQuotation:
          state.currentQuotation?.id === action.payload.id
            ? action.payload
            : state.currentQuotation,
      };
    case types.UPDATE_QUOTATION_STATUS_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    // ── Convert ───────────────────────────────────────────────────────────────
    case types.CONVERT_QUOTATION_REQUEST:
      return { ...state, actionLoading: true, error: null };
    case types.CONVERT_QUOTATION_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        quotations: replaceInList(state.quotations, action.payload),
        currentQuotation:
          state.currentQuotation?.id === action.payload.id
            ? action.payload
            : state.currentQuotation,
      };
    case types.CONVERT_QUOTATION_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    // ── Comparative ───────────────────────────────────────────────────────────
    case types.FETCH_COMPARATIVE_STATEMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_COMPARATIVE_STATEMENT_SUCCESS:
      return { ...state, loading: false, comparativeData: action.payload || [] };
    case types.FETCH_COMPARATIVE_STATEMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.CLEAR_QUOTATION_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};

export default quotationReducer;
